const profileOptionsForAll = [
  // { value: 1, label: "Please Select the type uprights" },
  { value: 3, label: "Option1 - 80mm uprights, Standard 2.0mm Thk" },
  { value: 4, label: "Option1 - 80mm uprights, 2.3mmThk" },
  { value: 6, label: "Option2 - 80mm uprights, 2.0mmThk" },
  { value: 7, label: "Option2 - 80mm uprights, 2.3mmThk" },
  { value: 11, label: "Option1 - 100mm uprights, Standard 2.0mmThk" },
  { value: 13, label: "Option1 - 120mm uprights, 2.5mmThk" },
  { value: 14, label: "Option2 - 100mm uprights, Standard 2.0mmThk" },
  { value: 16, label: "Option2 - 120mm uprights, 2.5mmThk" },
  { value: 20, label: "Sperrin - 80mm uprights, MK2, 2.3mm Thk" },
  { value: 21, label: "NEW - Option1 - 100mm MK3 uprights - 2.0mm THK" },
  { value: 23, label: "NEW - Option1 - 120mm MK3 uprights - 2.0mm THK" },
  { value: 24, label: "NEW - Option1 - 120mm MK3 uprights - 2.5mm THK" },
];

const profileOptionsForOption1 = [
  // { value: 1, label: "Please Select the type uprights" },
  { value: 3, label: "Option1 - 80mm uprights, Standard 2.0mm Thk" },
  { value: 4, label: "Option1 - 80mm uprights, 2.3mmThk" },
  { value: 11, label: "Option1 - 100mm uprights, Standard 2.0mmThk" },
  { value: 13, label: "Option1 - 120mm uprights, 2.5mmThk" },
  { value: 20, label: "Sperrin - 80mm uprights, MK2, 2.3mm Thk" },
  { value: 21, label: "NEW - Option1 - 100mm MK3 uprights - 2.0mm THK" },
  { value: 23, label: "NEW - Option1 - 120mm MK3 uprights - 2.0mm THK" },
  { value: 24, label: "NEW - Option1 - 120mm MK3 uprights - 2.5mm THK" },
];

const profileOptionsForOption2 = [
  // { value: 1, label: "Please Select the type uprights" },
  { value: 6, label: "Option2 - 80mm uprights, 2.0mmThk" },
  { value: 7, label: "Option2 - 80mm uprights, 2.3mmThk" },
  { value: 14, label: "Option2 - 100mm uprights, Standard 2.0mmThk" },
  { value: 16, label: "Option2 - 120mm uprights, 2.5mmThk" },
];

const heavyProfileOptionsForAll = [
  // { value: 1, label: "Select Heavier uprights" },
  { value: 3, label: "Option1 - 80mm uprights, Standard 2.0mm Thk" },
  { value: 4, label: "Option1 - 80mm uprights, 2.3mm Thk" },
  { value: 6, label: "Option2 - 80mm uprights, 2.0mm Thk" },
  { value: 7, label: "Option2 - 80mm uprights, 2.3mm Thk" },
  { value: 11, label: "Option1 - 100mm uprights, Standard 2.0mm Thk" },
  { value: 13, label: "Option1 - 120mm uprights, 2.5mmThk" },
  { value: 14, label: "Option2 - 100mm uprights, Standard 2.0mm Thk" },
  { value: 16, label: "Option2 - 120mm uprights, 2.5mmThk" },
  { value: 20, label: "Sperrin - 80mm uprights, MK2, 2.3mm Thk" },
  { value: 21, label: "TEST" },
];

const heavyProfileOptionsForOption1 = [
  // { value: 1, label: "Select Heavier uprights" },
  { value: 3, label: "Option1 - 80mm uprights, Standard 2.0mm Thk" },
  { value: 4, label: "Option1 - 80mm uprights, 2.3mm Thk" },
  { value: 11, label: "Option1 - 100mm uprights, Standard 2.0mm Thk" },
  { value: 13, label: "Option1 - 120mm uprights, 2.5mmThk" },
  { value: 20, label: "Sperrin - 80mm uprights, MK2, 2.3mm Thk" },
  { value: 21, label: "TEST" },
];

const heavyProfileOptionsForOption2 = [
  // { value: 1, label: "Select Heavier uprights" },
  { value: 6, label: "Option2 - 80mm uprights, 2.0mm Thk" },
  { value: 7, label: "Option2 - 80mm uprights, 2.3mm Thk" },
  { value: 14, label: "Option2 - 100mm uprights, Standard 2.0mm Thk" },
  { value: 16, label: "Option2 - 120mm uprights, 2.5mmThk" },
];

const crossSectionOptions = [
  // { value: 1, label: "Please Select Cross-Beam" },
  // { value: 2, label: "Open Beam 60mm, 1.7mm THK" },
  // { value: 3, label: "Open Beam 87mm, 1.7mm THK" },
  // { value: 4, label: "Open Beam 101mm, 1.7mm THK" },
  { value: 5, label: "Open Beam 101 mm, 2.25mm THK" },
  { value: 6, label: "Boxed Beam 86mm, 1.5mm THK" },
  { value: 7, label: "Boxed Beam 86mm, 1.55mm THK" },
  // { value: 8, label: "Boxed Beam 86mm, 1.7mm THK" },
  { value: 9, label: "Boxed Beam 86mm, 1.8mm THK" },
  { value: 10, label: "Boxed Beam 95mm, 1.5mm THK" },
  // { value: 11, label: "Boxed Beam 95mm, 1.7mm THK" },
  { value: 12, label: "Boxed Beam 95mm, 1.8mm THK" },
  { value: 13, label: "Boxed Beam 103mm, 1.5mm THK" },
  { value: 14, label: "Boxed Beam 103mm, 1.65mm THK" },
  // { value: 15, label: "Boxed Beam 103mm, 1.7mm THK" },
  { value: 16, label: "Boxed Beam 103mm, 1.8mm THK" },
  { value: 17, label: "Boxed Beam 123mm, 1.5mm THK" },
  // { value: 18, label: "Boxed Beam 123mm, 1.7mm THK" },
  { value: 19, label: "Boxed Beam 123mm, 1.8mm THK" },
  { value: 20, label: "Boxed Beam 146mm, 1.5mm THK" },
  // { value: 21, label: "Boxed Beam 146mm, 1.7mm THK" },
  { value: 22, label: "Boxed Beam 146mm, 1.8mm THK" },
  { value: 23, label: "Boxed Beam 146mm, 1.85mm THK" },
  { value: 24, label: "Z Beam 54mm, 2.0mm THK" },
  { value: 25, label: "Z Beam 54mm, 2.5mm THK" },
  { value: 26, label: "Z Beam 74mm, 2.0mm THK" },
  { value: 27, label: "Z Beam 74mm, 2.5mm THK" },
  { value: 28, label: "Z Beam 54mm, 1.6mm THK" },
  { value: 29, label: "Premium Boxed Beam 70mm, 1.5mmTHK" },
  // { value: 30, label: "Premium Boxed Beam 70mm, 1.7mmTHK" },
  { value: 31, label: "Premium Boxed Beam 90mm, 1.5mmTHK" },
  // { value: 32, label: "Premium Boxed Beam 90mm, 1.7mmTHK" },
  { value: 33, label: "Premium Boxed Beam 99mm, 1.5mmTHK" },
  // { value: 34, label: "Premium Boxed Beam 99mm, 1.7mmTHK" },
  { value: 35, label: "Premium Boxed Beam 110mm, 1.5mmTHK" },
  // { value: 36, label: "Premium Boxed Beam 110mm, 1.7mmTHK" },
  { value: 37, label: "Premium Boxed Beam 120mm, 1.5mmTHK" },
  // { value: 38, label: "Premium Boxed Beam 120mm, 1.7mmTHK" },
  { value: 39, label: "Premium Boxed Beam 139mm, 1.5mmTHK" },
  // { value: 40, label: "Premium Boxed Beam 139mm, 1.7mmTHK" },
  { value: 41, label: "Premium Boxed Beam 156mm, 1.5mmTHK" },
  // { value: 42, label: "Premium Boxed Beam 156mm, 1.7mmTHK" },
];

const connectionOptions = [
  { value: 1, label: "Bolted Cross-tie" },
  { value: 2, label: "Welded Cross-tie" },
];

const boltsOptions = [
  { value: 1, label: "ONE Bolt fixings per foot" },
  { value: 2, label: "TWO Bolt fixings per foot" },
];

const connectionStyleOptions = [
  { value: 1, label: "No" },
  { value: 2, label: "Yes" },
];

const beamLevelsOptions = [
  { value: 1, label: ">1" },
  { value: 2, label: "=1" },
];

const profileMenuOptions = [
  { value: 1, label: "All" },
  { value: 2, label: "Option 1" },
  { value: 3, label: "Option 2" },
];

const loadTypeOptions = [
  { value: 1, label: "Uniformly distributed Load" },
  { value: 2, label: "Two Point Loads as per SEMA" },
  { value: 3, label: "SEMA Deflection" },
  { value: 4, label: "Cantilever Beam" },
];

const beamMatrixData = {
  cprofiles: [null, 86, 95, 103, null, 123, null, 146, null],
  mprofiles: [70, 90, 99, null, 110, 120, 139, null, 156],
  lengths: [
    1000, 1050, 1100, 1150, 1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550,
    1600, 1650, 1700, 1750, 1800, 1850, 1900, 1950, 2000, 2050, 2100, 2150,
    2200, 2250, 2300, 2350, 2400, 2450, 2500, 2550, 2600, 2650, 2700, 2750,
    2800, 2850, 2900, 2950, 3000, 3050, 3100, 3150, 3200, 3250, 3300, 3350,
    3400, 3450, 3500, 3550, 3600, 3650, 3700, 3750, 3800, 3850, 3900, 3950,
    4000,
  ],
  matrix: [
    [7330, null, null, null, null, null, null, null, null],
    [6675, null, null, null, null, null, null, null, null],
    [6106, null, null, null, null, null, null, null, null],
    [5608, null, null, null, null, null, null, null, null],
    [5170, null, null, null, null, null, null, null, null],
    [4783, 7749, null, null, null, null, null, null, null],
    [4439, 7186, null, null, null, null, null, null, null],
    [4132, 6684, null, null, null, null, null, null, null],
    [3857, 6234, 7652, null, null, null, null, null, null],
    [3609, 5830, 7150, null, null, null, null, null, null],
    [3385, 5464, 6696, null, null, null, null, null, null],
    [3182, 5132, 6285, 7526, null, null, null, null, null],
    [2997, 4831, 5912, 7077, null, null, null, null, null],
    [2829, 4556, 5571, 6668, 7575, null, null, null, null],
    [2674, 4305, 5260, 6295, 7150, null, null, null, null],
    [2533, 4075, 4975, 5952, 6760, null, null, null, null],
    [2403, 3863, 4712, 5637, 6402, 7775, null, null, null],
    [2283, 3667, 4471, 5347, 6072, 7373, null, null, null],
    [2172, 3487, 4248, 5080, 5768, 7002, null, null, null],
    [2069, 3320, 4042, 4832, 5486, 6658, null, null, null],
    [1974, 3165, 3851, 4603, 5225, 6340, null, null, null],
    [1885, 3021, 3673, 4390, 4983, 6044, null, null, null],
    [1803, 2888, 3508, 4191, 4757, 5770, null, null, null],
    [1726, 2763, 3354, 4007, 4547, 5513, 7786, null, null],
    [1654, 2646, 3210, 3834, 4351, 5274, 7448, null, null],
    [1587, 2537, 3075, 3673, 4167, 5051, 7132, null, null],
    [1524, 2435, 2949, 3522, 3995, 4841, 6837, 7738, null],
    [1465, 2339, 2831, 3380, 3834, 4645, 6559, 7423, null],
    [1409, 2248, 2720, 3247, 3683, 4461, 6299, 7126, null],
    [1357, 2164, 2616, 3122, 3541, 4287, 6054, 6848, 7846],
    [1307, 2084, 2518, 3004, 3407, 4124, 5823, 6586, 7546],
    [1261, 2008, 2425, 2893, 3281, 3971, 5606, 6338, 7262],
    [1217, 1937, 2337, 2788, 3161, 3825, 5401, 6105, 6994],
    [1175, 1870, 2255, 2689, 3049, 3688, 5207, 5885, 6742],
    [1136, 1806, 2176, 2595, 2942, 3559, 5024, 5677, 6503],
    [1098, 1746, 2102, 2506, 2841, 3436, 4851, 5480, 6277],
    [1063, 1688, 2032, 2422, 2746, 3320, 4686, 5293, 6062],
    [1029, 1634, 1966, 2342, 2655, 3209, 4530, 5116, 5859],
    [997, 1582, 1902, 2266, 2569, 3104, 4382, 4947, 5666],
    [967, 1533, 1842, 2194, 2487, 3005, 4241, 4788, 5483],
    [938, 1486, 1785, 2126, 2409, 2910, 4108, 4636, 5308],
    [910, 1442, 1730, 2060, 2335, 2820, 3980, 4491, 5142],
    [884, 1399, 1678, 1998, 2264, 2734, 3859, 4353, 4984],
    [858, 1359, 1629, 1939, 2197, 2652, 3743, 4221, 4833],
    [834, 1320, 1581, 1882, 2132, 2574, 3632, 4096, 4689],
    [811, 1283, 1536, 1828, 2071, 2499, 3527, 3976, 4552],
    [789, 1248, 1493, 1776, 2012, 2428, 3426, 3862, 4421],
    [768, 1214, 1452, 1727, 1956, 2359, 3329, 3752, 4295],
    [748, 1181, 1412, 1680, 1902, 2294, 3237, 3647, 4175],
    [729, 1150, 1374, 1634, 1851, 2231, 3149, 3547, 4060],
    [710, 1121, 1338, 1591, 1801, 2171, 3064, 3451, 3950],
    [692, 1092, 1303, 1549, 1754, 2114, 2983, 3359, 3844],
    [675, 1065, 1269, 1509, 1708, 2059, 2905, 3271, 3743],
    [659, 1038, 1237, 1471, 1665, 2006, 2830, 3186, 3645],
    [643, 1013, 1206, 1434, 1623, 1955, 2758, 3104, 3552],
    [628, 988, 1177, 1398, 1583, 1906, 2689, 3026, 3462],
    [613, 965, 1148, 1364, 1544, 1859, 2623, 2951, 3376],
    [599, 942, 1121, 1331, 1507, 1814, 2559, 2878, 3293],
    [586, 921, 1094, 1300, 1471, 1770, 2497, 2809, 3213],
    [573, 900, 1069, 1269, 1436, 1728, 2438, 2741, 3136],
    [560, 879, 1044, 1240, 1403, 1688, 2381, 2677, 3062],
  ],
};

export {
  beamLevelsOptions,
  beamMatrixData,
  boltsOptions,
  connectionOptions,
  connectionStyleOptions,
  crossSectionOptions,
  heavyProfileOptionsForAll,
  heavyProfileOptionsForOption1,
  heavyProfileOptionsForOption2,
  loadTypeOptions,
  profileMenuOptions,
  profileOptionsForAll,
  profileOptionsForOption1,
  profileOptionsForOption2,
};
